/**
 * The info map of question component
 */
export var allQuoteQuestionInfoMap = {
  // MsAmlin
  quoted_PI_selected_question_1: {
    title: 'Do you agree with the following?',
    confirmType: '1',
    spec: [{
      list: [{
        text: 'My client is responsible for the final review and sign-off of my work'
      }, {
        text: "I do not retain 'business critical' decision-making responsibility on behalf of my client"
      }]
    }]
  },
  quoted_construction_selected: {
    title: 'Are you involved in the design, specification, supervision, inspection or construction of, or in the observation of the construction of any real property?',
    confirmType: '2',
    spec: [],
    reverse: true
  },
  quoted_construction_following_question: {
    title: 'Does any of the following apply to you?',
    confirmType: '2',
    spec: [{
      list: [{
        text: 'Only work for one client at a time on short-term assignments'
      }, {
        text: 'Get paid on a daily or hourly rate'
      }, {
        text: 'Placed into contract by a third-party agency'
      }]
    }]
  },
  quoted_PL_selected_question_1: {
    title: 'Do you undertake any of the following activities?',
    confirmType: '2',
    spec: [{
      list: [{
        text: 'Manual work'
      }, {
        text: 'Rope access work'
      }, {
        text: 'Welding or any other work which involves the application of heat'
      }, {
        text: 'Any work at height'
      }, {
        text: 'Manufacture, construction, repair, service, treatment, sale, supply or distribution of any tangible product'
      }]
    }],
    reverse: true
  },
  quoted_railL_selected: {
    title: 'Do you undertake any of the following?',
    confirmType: '2',
    spec: [{
      list: [{
        text: 'Work within any Red Zone or on or within 10 metres of any Open Line'
      }, {
        text: 'Provide services that could impact the provision of power to rails or signals'
      }]
    }],
    reverse: true
  },
  quoted_aviation_selected: {
    title: 'Do you undertake any work on or near aircraft, on the runway, or runway apron?',
    confirmType: '2',
    spec: [],
    reverse: true
  },
  quoted_confirm_statement: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Claims',
      list: [{
        text: 'No claim, successful or otherwise has been made against me/us, any predecessor in business, or any past or present director, partner, proprietor  or employee (whether previously insured or not)'
      }, {
        text: 'I/we are not aware of any circumstance or event which may give rise to a claim.'
      }]
    }, {
      text: 'Limitation of Services',
      list: [{
        text: 'I/we provide office-based services and do not undertake any manual work.'
      }, {
        text: 'No services provided outside of the UK are undertaken for a period exceeding 12 months.'
      }]
    }, {
      text: 'Excluded services and IR35',
      list: [{
        text: 'I/we have read the Summary of Cover and are not seeking coverage for any of the ‘Excluded Services’ listed in that document.'
      }, {
        text: "I/we agree to the Terms of service for the free 'IR35 Contract Review Assessment' contained here."
      }]
    }]
  },
  // Accelerant
  // Chubb
  technologyIndustry: {
    title: 'Do you work in the tech industry?',
    confirmType: '2',
    spec: []
  },
  contract1M: {
    title: 'Do you have any one single contract worth more than £1m?',
    confirmType: '2',
    spec: [],
    reverse: true
  },
  undertakenWork: {
    title: 'Does your work involve services to, or development of products in any of the following activities, applications or industries:',
    confirmType: '2',
    spec: [],
    reverse: true
  },
  chubb_declaration_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Claims',
      list: [{
        text: 'You have not had a claim within the last 3 years.'
      }, {
        text: 'You or any person proposing for insurance are not aware, after enquiry, of any investigation, circumstance or incident that you have reason to suppose might afford grounds for any future claim which has not already been advised to us,'
      }]
    }, {
      text: 'Sanctioned jurisdictions',
      list: [{
        text: "You do not deliver any products or services for IRAN, SYRIA, CUBA, NORTH KOREA, SUDAN, VENEZUELA, RUSSIA, CRIMEA, DONETSK PEOPLE'S REPUBLIC (DNR) OR LUHANSK PEOPLE'S REPUBLIC (LNR) REGIONS OF THE UKRAINE or any jurisdiction noted under applicable trade and/or economic sanctions laws and regulations (e.g., US, Canada, UN, UK or EU)."
      }]
    }, {
      text: 'Project specification and agreement',
      list: [{
        text: 'When you start your contract:',
        hideDot: true
      }, {
        text: 'You are working to a documented specification defined by the client which is contracting you for this work.'
      }, {
        text: 'You have a written and signed contract with your client which defines your roles and the project scope.'
      }]
    }]
  },
  chubb_declaration_p2: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Project specification and agreement',
      list: [{
        hideDot: true,
        text: 'When you start your contract,'
      }, {
        text: 'You are working to a documented specification defined by the client which is contracting you for this work'
      }, {
        text: 'You have a written and signed contract with your client which defines your roles and the project scope'
      }]
    }]
  },
  // Goods in transit
  question_good_in_transit_vehicle_and_removers: {
    title: 'Please confirm whether you agree or disagree with these statements:',
    confirmType: '1',
    spec: [{
      list: [{
        text: 'You do not transport livestock or perishable items.'
      }, {
        text: 'You only transport motorised vehicles by trailer/transporter and NOT by their own power.'
      }, {
        text: 'You do not transport motorised vehicles, livestock or perishable items.'
      }]
    }]
  },
  // Greate american
  broker_declaration_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Claims',
      list: [{
        hideDot: true,
        text: 'Your business has not been involved in any losses, claims or incidents that may result in a claim within the last 5 years.'
      }]
    }, {
      text: 'Convictions, CCJs and disqualifications',
      list: [{
        text: 'Your principals, partners, directors or trustees of this business have not been convicted or charged for a criminal offence (non motoring) or have received a civil.'
      }, {
        text: 'Your principlas, partners, directors or trustees of this business have not previously declared bankrupt, insolvent or gone into liquidation or have outstanding CCJ.'
      }]
    }, {
      text: 'Previous insurance',
      list: [{
        text: 'You have never been declined or refused insurance cover or had cover cancelled or been subject to special terms in respect of any cover that you have asked.'
      }, {
        text: 'You are not aware of circumstances which might give rise to a claim.'
      }]
    }]
  },
  broker_declaration_directors_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Material facts',
      list: [{
        text: 'The company have a positive net worth for each of the last two years.'
      }, {
        text: 'No insured party is disqualified, or has been disqualified in the past, from holding a licence or post.'
      }, {
        text: 'No litigation has been brought against past or present directors or officers of the company.'
      }, {
        text: 'The company does not work in any of the following：',
        list: [{
          text: 'Financial Sector'
        }, {
          text: 'High Tech'
        }, {
          text: 'Legal Sector'
        }, {
          text: 'Professional Sports Clubs'
        }, {
          text: 'Speculative Exploration'
        }, {
          text: 'Bio-tech company'
        }]
      }]
    }]
  },
  broker_declaration_employment_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Material facts',
      list: [{
        text: 'The proposer has written grievance procedure in place that is regularly communicated.'
      }, {
        text: 'There is no employee layoffs in the last 12 months or next 12 months.'
      }, {
        text: 'The company has no employees based in the USA.'
      }]
    }]
  },
  broker_declaration_cyber_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      list: [{
        hideDot: true,
        text: "Insured's website is not critical for the day to day operations of the organisation."
      }]
    }]
  },
  broker_declaration_cyber_crime_p1: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Material facts',
      list: [{
        text: 'The business has established policy for checking background of job candidates prior to them being offered the job.'
      }, {
        text: 'The business undertakes stock check at least once every 12 months.'
      }, {
        text: 'The business has established process for vetting and approving new suppliers.'
      }, {
        text: 'There is dual control with regards to all payments including signing of cheques and electronic funds transfer.'
      }, {
        text: 'Separate finance consolidation: The Bank statements are not reconciled by persons authorised to deposit or withdraw funds.'
      }]
    }]
  },
  great_american_fast_process_declaration: {
    title: '',
    confirmType: '1',
    spec: [{
      text: 'Acceptace criteria',
      list: [{
        text: 'You agree with all of the following statements:',
        hideDot: true
      }, {
        text: 'Your cargo insurance has not been cancelled or non-renewed within the past 5 years;'
      }, {
        text: 'You have not been insured by Great America in the past 5 years;'
      }, {
        text: 'You have not been hauling goods under a different name wtihin the past 5 years.'
      }]
    }, {
      text: 'Drivers',
      list: [{
        text: 'You declare that:',
        hideDot: true
      }, {
        text: 'All drivers are between the ages of 23-65;'
      }, {
        text: 'or, in case there are drivers up to 70 years old:',
        hideDot: true
      }, {
        text: 'All drivers between the age of 66-70 presented a copy of acceptable DOT physically at the time of binding.'
      }]
    }, {
      text: 'Minor violations',
      list: [{
        text: 'You declare that, within the past 3 years, you did not have more than three minor violations, including, but not limited to:',
        hideDot: true
      }, {
        text: 'Speeding;'
      }, {
        text: 'Driving while operating a handheld device;'
      }, {
        text: 'Texting while driving;'
      }, {
        text: 'Improper Lane Changes;'
      }, {
        text: 'Failure to Yield;'
      }, {
        text: 'Running Red Lights or Stop Signs.'
      }]
    }, {
      text: 'Bankruptcy',
      list: [{
        text: 'You (or any director or partner of the business) have not been filed for bankruptcy within the past 5 years.',
        hideDot: true
      }]
    }, {
      text: 'Hauling activities and prior experience',
      list: [{
        text: 'All drivers have at least 2 years experience transporting similar type commodities.'
      }, {
        text: 'No driver had any of the following Major Violations in the past 36 months:',
        list: [{
          text: 'DWI/DUI'
        }, {
          text: 'Refusing a substance test'
        }, {
          text: 'Reckless driving'
        }, {
          text: 'Eluding a police officer'
        }, {
          text: 'Manslaughter'
        }, {
          text: 'Driving while license is suspended'
        }, {
          text: 'Hit and run'
        }, {
          text: 'Any Felony(charge or conviction)'
        }, {
          text: 'Drag Racing'
        }]
      }, {
        text: 'No single driver have 4 or more minor violations.'
      }, {
        text: 'No driver haul commodities in an open pickup truck bed.'
      }, {
        text: 'No driver ever haul any oversized (exceeds 8 ft. 6 in. wide or 13 ft. 6 in. in height from road surface) or overweight (exceeds 46,000 lbs. gross weight) loads.'
      }, {
        text: 'We do not ever leave loaded trailers detached from power unit.'
      }, {
        text: 'We no not ever leave loaded trailer unattended.'
      }]
    }]
  }
};